import ActionButton from '@repo/ui/action-button'
import { DeleteIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'

import { deleteBudgetAllocation } from '../../../api/buget-allocation/delete-buget-allocation'

interface Props {
  id: number
  onDelete: () => void
}

const BudgetAllocationDeleteButton = ({ id, onDelete }: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: deleteBudgetAllocation,
    onSuccess: onDelete
  })

  return (
    <ActionButton
      variant="danger"
      icon={DeleteIcon}
      isLoading={isPending}
      onClick={() => mutate(id)}
    />
  )
}

export default BudgetAllocationDeleteButton
